import { render, staticRenderFns } from "./ShipmentSettlement.vue?vue&type=template&id=784e93e3"
import script from "./ShipmentSettlement.vue?vue&type=script&lang=js"
export * from "./ShipmentSettlement.vue?vue&type=script&lang=js"
import style0 from "./ShipmentSettlement.vue?vue&type=style&index=0&id=784e93e3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports